export interface ArrowRightIconProps {
  color: string;
  height: number;
  width: number;
}
const ArrowRightIcon = ({ color, height, width }: ArrowRightIconProps) => {
  return (
    <div className="flex justify-center items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 15 15"
        fill="none"
      >
        <path
          d="M2.49707 7.4987H12.4971M12.4971 7.4987L7.8304 12.1654M12.4971 7.4987L7.8304 2.83203"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ArrowRightIcon;
